import React from 'react';

import './not-found.scss';

class NotFound extends React.Component {
  render() {
    return (
      <div className="not-found">
        <h1>Page Not Found</h1>
        <p>Whoops! The page you are looking for does not exist.</p>
      </div>
    );
  }
}

export default NotFound;
